import "./App.scss";
import Header from "./components/Header";
import Home from "./components/Home";
import WhoIWorkFor from "./components/WhoIWorkFor";
import AboutUs from "./components/About";
import Services from "./components/Services";
import Portfolio from "./components/Portfolio";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import { useEffect, useRef, useState } from "react";
import { usePageReveal } from "./hooks/usePageReveal";
import ClassicHeader from "./components/ClassicHeader";
import { commonConfig } from "./config/commonConfig";
import TermsAndConditions from "./components/TermsAndConditions";
import Disclaimer from "./components/Disclaimer";
import PreLoader from "./components/Preloader";
import { Tooltip } from "./components/Tooltip";

function MainApp() {
  const classicHeader = commonConfig.classicHeader;
  
  // Dark mode state management with localStorage persistence
  const [darkTheme, setDarkTheme] = useState(() => {
    const savedTheme = localStorage.getItem('darkTheme');
    return savedTheme ? JSON.parse(savedTheme) : true; // Default to dark mode
  });

  // Toggle dark mode function
  const toggleDarkMode = () => {
    const newTheme = !darkTheme;
    setDarkTheme(newTheme);
    localStorage.setItem('darkTheme', JSON.stringify(newTheme));
  };


  const handleNavClick = (section) => {
    document.getElementById(section).scrollIntoView({ behavior: "smooth" });
  };

  const [scrollTopVisible, setScrollTopVisible] = useState(false);
  const [isLoading, setisLoading] = useState(true);
  const pageRef = useRef(null);
  usePageReveal(pageRef, !isLoading);


  useEffect(() => {
    const loadingTimeout = setTimeout(() => {
      setisLoading(false);
    }, 1000);
    return () => {
      clearTimeout(loadingTimeout);
    };
  }, []);

  // Apply dark theme to body
  useEffect(() => {
    if (darkTheme) {
      document.body.classList.add("dark-theme");
    } else {
      document.body.classList.remove("dark-theme");
    }
  }, [darkTheme]);

  useEffect(() => {
    const checkScrollTop = () => setScrollTopVisible(window.scrollY > 400);
    window.addEventListener("scroll", checkScrollTop, { passive: true });
    checkScrollTop();
    return () => window.removeEventListener("scroll", checkScrollTop);
  }, []);

  return (
    <>
      <div
        ref={pageRef}
        style={{ position: "relative" }}
        className={classicHeader ? "" : "side-header"}
      >
        {isLoading && <PreLoader></PreLoader>}

        <div id="main-wrapper">
          {classicHeader ? (
            <ClassicHeader 
              handleNavClick={handleNavClick}
              darkTheme={darkTheme}
              toggleDarkMode={toggleDarkMode}
            ></ClassicHeader>
          ) : (
            <Header 
              handleNavClick={handleNavClick}
              darkTheme={darkTheme}
              toggleDarkMode={toggleDarkMode}
            ></Header>
          )}

          <div id="content" role="main">
            <Home
              classicHeader={classicHeader}
              darkTheme={darkTheme}
              handleNavClick={handleNavClick}
            ></Home>
            <WhoIWorkFor
              classicHeader={classicHeader}
              darkTheme={darkTheme}
            ></WhoIWorkFor>
            <Services
              classicHeader={classicHeader}
              darkTheme={darkTheme}
            ></Services>
            <Portfolio
              classicHeader={classicHeader}
              darkTheme={darkTheme}
            ></Portfolio>
            <AboutUs
              classicHeader={classicHeader}
              darkTheme={darkTheme}
            ></AboutUs>
            {/* Testimonials section temporarily hidden */}
            {/* <Testimonials
              classicHeader={classicHeader}
              darkTheme={darkTheme}
            ></Testimonials> */}
            <Contact
              classicHeader={classicHeader}
              darkTheme={darkTheme}
            ></Contact>
          </div>
          <Footer
            classicHeader={classicHeader}
            darkTheme={darkTheme}
            handleNavClick={handleNavClick}
          ></Footer>
        </div>
        {/* back to top */}
        <Tooltip text="Back to Top" placement="left">
          <span
            id="back-to-top"
            className="rounded-circle"
            style={{ display: scrollTopVisible ? "inline" : "none" }}
            onClick={() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
          >
            <i className="fa fa-chevron-up"></i>
          </span>
        </Tooltip>

        <TermsAndConditions darkTheme={darkTheme}></TermsAndConditions>
        <Disclaimer darkTheme={darkTheme}></Disclaimer>
      </div>
    </>
  );
}

export default MainApp;
